<template>
  <section>
    <div class="container">

    </div>
  </section>
</template>
<script>
import Vue from 'vue';

export default {
  props: ['page'],
  data: function() {
    return {
      
    }
  },
  mounted: function() {
    var _this = this;
    Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });
  },
  methods: {

  }
}

</script>


// WEBPACK FOOTER //
// tmdk.vue?411d17d6